import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';

/**
 *
 * Возвращает id услуги, которая отображается внутри карточки ставки
 */
export function selectPromotionServiceId(state: IAppState): EServiceId | null {
  return state.publishTerms.promotionServiceId;
}
